module.exports = __webpack_public_path__ + "img/dateline_3.88b16e8e.png";